/** Central route path registry, mirroring the convention used in
 * mobile/src/navigation/routes.js -- pages and nav links both reference
 * these instead of hand-typing paths. */
export const ROUTES = {
  HOME: "/",
  ACCESS_REQUEST: "/access-request",
  REVIEW_ACCESS_REQUESTS: "/security/access-requests",

  SECURITY_MONITORING: "/security/monitoring",
  AUDIT_LOG: "/security/audit-log",
  COMPLIANCE: "/security/compliance",

  THEME_ANALYTICS: "/analytics/theme",
  SUBSCRIPTION_ANALYTICS: "/analytics/subscription",
  FEATURE_ADOPTION: "/analytics/feature-adoption",
  DORMANT_ACCOUNTS: "/analytics/dormant-accounts",
  COST_MONITORING: "/analytics/cost",
  SENTIMENT_ANALYSIS: "/analytics/sentiment",
  MOBILE_ANALYTICS: "/analytics/mobile",
  BLOOM_ANALYTICS: "/analytics/bloom",

  SUPPORT_TICKETS: "/operations/support-tickets",
  PERFORMANCE_MONITORING: "/operations/performance",
  APP_INSIGHTS: "/operations/app-insights",

  USER_MANAGEMENT: "/management/users",
  FEATURE_FLAGS: "/management/feature-flags",
  SYSTEM_MANAGEMENT: "/management/system",

  CUSTOM_REPORTING: "/reports/custom",
};
